import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

const designBreakPoint = '720px';

export const ContentContainer = styled.div`
  padding: 110px 0 0;
  margin-top: 0.5rem;
  display: flex;
  gap: 20px;

  @media (max-width: ${designBreakPoint}) {
    padding: 60px 0 0;
    flex-direction: column-reverse;
  }
  ${(props) =>
    props.center &&
    css`
      justify-content: center;
    `}
`;

export const ChallengeDescription = styled.p`
  color: ${({ theme }) => theme.info};
  white-space: pre-wrap;
  font-size: 14px;
  word-wrap: break-word;
  word-break: break-all;
  & img {
    max-width: 100%;
  }

  ${(props) =>
    props.isCoursePage &&
    css`
      word-break: break-word;
      line-height: 28px;
    `}
`;

export const ChallengeLabel = styled.span`
  color: ${({ theme }) => theme.communityList.selectedColor};
  font-weight: 500;
  font-size: 1.5rem;
  margin-bottom: 10px;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: flex-start;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};

      @media (max-width: ${designBreakPoint}) {
        width: 100%;
      }
    `}

  ${({ center }) =>
    center &&
    css`
      flex-direction: row;
      justify-content: center;
    `}

  ${(props) =>
    props.right &&
    css`
      flex: 0 0 auto;
      margin-left: 20px;

      @media (max-width: ${designBreakPoint}) {
        margin-left: 0;
      }
    `}
`;

export const SectionColumn = styled.div`
  display: flex;
  flex-direction: column;
  ${({ noGap }) =>
    !noGap &&
    css`
      gap: 1rem;
    `}
`;

export const AuthorAvatar = styled.div`
  border-radius: 50%;
  width: 35px;
  height: 35px;
  background-image: url(${(props) => props.image || ''});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
`;

export const AuthorContainer = styled.div`
  display: flex;
  color: ${colors.darkGray};
  align-items: center;
  font-size: 14px;
`;

export const AuthorName = styled.a`
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  text-decoration: none;
  padding-left: 10px;
  color: ${({ theme }) => theme.info};

  :hover {
    text-decoration: none;
    color: ${({ theme }) => theme.info};
  }
`;

export const MetaInfoRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
  width: 100%;
  margin-bottom: 20px;
`;

export const Title = styled.h1`
  font-size: 3rem;
  color: ${({ theme }) => theme.communityList.selectedColor};
`;

export const MetaInfoContainer = styled.div`
  flex: 1 1 40%;
`;

export const LinkAndImageContainer = styled.div`
  flex: 1 1 60%;
`;

export const SelectedItemImage = styled.img`
  width: 100%;
  border-radius: 24px;
`;

export const RatingAndTagsContainer = styled.div`
  color: ${({ theme }) => theme.communityList.selectedColor};
  display: flex;
  width: 100%;
  text-wrap: nowrap;
  gap: 20px;
`;

export const RatingContainer = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
`;

export const RatingLabel = styled.span`
  color: ${({ theme }) => theme.communityList.selectedColor};
  margin-right: 10px;
`;

export const TagsContainer = styled.div`
  width: 100%;
  padding-top: 18px;

  ${({ isCoursePage }) =>
    isCoursePage &&
    css`
      padding: 15px 0;
    `}
`;

export const ButtonsContainer = styled.div`
  min-height: 4rem;
  align-items: center;
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 20px;
  @media (max-width: ${designBreakPoint}) {
    margin-top: 20px;
    flex-direction: column;
    text-align: center;
  }
`;

export const BigText = styled.span`
  font-size: 3rem;
`;

export const StarIcon = styled.i.attrs(() => ({ className: 'fa-solid fa-star' }))`
  padding: 7px;
  position: relative;
  top: -5px;
`;

export const RatingAndShareContainer = styled.div`
  display: flex;
  margin-left: auto;
  @media (max-width: ${designBreakPoint}) {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
`;

export const RatingAlignRow = styled.div`
  padding-right: 15px;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
`;

export const SponsorLogo = styled.div`
  position: relative;
  width: calc(100% - 1rem);
  height: 100%;
  min-height: 2rem;
  max-height: 5rem;
  background-image: url(${(props) => props.image || ''});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
`;

export const ShareButtonContainer = styled.div`
  margin-top: 10px;
  text-align: right;
  @media (max-width: ${designBreakPoint}) {
    text-align: left;
  }
`;
